import createApolloClient from '../../../core/createApolloClient/createApolloClient.client';
import { getp } from '../../../helpers/getProp';
import gql from 'graphql-tag';

const client = createApolloClient();

const mutation = gql`
  mutation($reportType: String!, $listId: Int) {
    CreateReportUser(reportType: $reportType, listId: $listId) {
      status
    }
  }
`;

export default async function(listId, reportType) {
  const res = await client.mutate({
    mutation,
    variables: { listId, reportType },
  });

  const status = getp(res, 'data.CreateReportUser.status');
  if (status !== 'success') {
    console.log('Report error : ', res);
  }
  return status;
}



// WEBPACK FOOTER //
// ./src/routes/presentation/Details/reportListingMFn.js